<div class="modal-inner restaurant-settle-dialog nunito">
  <div class="modal-header style-2 restaurant-settle-dialog__header">
    <div>
      <span class="restaurant-settle-dialog__context">
        {{ 'restaurantSplitBill.tableNumber' | translate: { tableNumber: data.tableNumber } }}
      </span>
      <h3 id="restaurant-settle-title">{{ stepLabel }}</h3>
    </div>
    <button
      type="button"
      class="close-btn"
      [attr.aria-label]="'restaurantSplitBill.close' | translate"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div
    class="modal-body restaurant-settle-dialog__body"
    [class.restaurant-settle-dialog__body--setup]="step === 'setup'"
    [class.restaurant-settle-dialog__body--payment]="step === 'payment'"
  >
    <div class="restaurant-settle-dialog__loading" *ngIf="loading">
      <mat-spinner diameter="32"></mat-spinner>
      <span>{{ 'restaurantSplitBill.loading' | translate }}</span>
    </div>

    <ng-container *ngIf="!loading">
      <div class="restaurant-settle-dialog__error" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>
      <div class="restaurant-settle-dialog__notice" role="status" *ngIf="noticeMessage">
        {{ noticeMessage }}
      </div>

      <section *ngIf="step === 'choose'" aria-labelledby="restaurant-settle-title">
        <p class="restaurant-settle-dialog__intro">{{ 'restaurantSplitBill.paymentQuestion' | translate }}</p>
        <mat-radio-group
          class="restaurant-settle-dialog__choices"
          [(ngModel)]="mode"
          [attr.aria-label]="'restaurantSplitBill.paymentQuestion' | translate"
        >
          <div class="payment-choice" [class.is-selected]="mode === 'single'">
            <mat-radio-button value="single">
              <strong>{{ 'restaurantSplitBill.onePayment' | translate }}</strong>
              <span>{{ 'restaurantSplitBill.onePaymentDescription' | translate }}</span>
            </mat-radio-button>
          </div>
          <div class="payment-choice" [class.is-selected]="mode === 'equal'">
            <mat-radio-button value="equal">
              <strong>{{ 'restaurantSplitBill.splitEqually' | translate }}</strong>
              <span>{{ 'restaurantSplitBill.splitEquallyDescription' | translate }}</span>
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </section>

      <section *ngIf="step === 'setup'" aria-labelledby="restaurant-settle-title">
        <p class="restaurant-settle-dialog__intro">
          {{ 'restaurantSplitBill.splitGuestPrompt' | translate }}
        </p>
        <h4 class="review-section-label">{{ 'restaurantSplitBill.splitDetails' | translate }}</h4>
        <div class="split-setup">
          <div class="split-count">
            <label class="split-count__label" for="split-guest-count">
              {{ 'restaurantSplitBill.numberOfGuests' | translate }}
            </label>
            <div class="split-count__control">
              <button
                type="button"
                [disabled]="saving || participantCount <= 2"
                [attr.aria-label]="'restaurantSplitBill.decreaseGuests' | translate"
                (click)="setParticipantCount(participantCount - 1)"
              >
                <mat-icon>remove</mat-icon>
              </button>
              <input
                id="split-guest-count"
                class="split-count__input"
                type="number"
                min="2"
                max="20"
                step="1"
                inputmode="numeric"
                [disabled]="saving"
                [ngModel]="participantCount"
                (ngModelChange)="setParticipantCount($event)"
              />
              <button
                type="button"
                [disabled]="saving || participantCount >= 20"
                [attr.aria-label]="'restaurantSplitBill.increaseGuests' | translate"
                (click)="setParticipantCount(participantCount + 1)"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>

          <div class="equal-preview" *ngIf="mode === 'equal'">
            <div>
              <span>{{ 'restaurantSplitBill.totalBill' | translate }}</span>
              <strong [innerHTML]="currencyAmount(data.totals.totalCents)"></strong>
            </div>
            <div>
              <span>{{ 'restaurantSplitBill.perGuest' | translate }}</span>
              <strong [innerHTML]="currencyAmount(equalShareCents)"></strong>
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="step === 'review'" aria-labelledby="restaurant-settle-title">
        <p class="restaurant-settle-dialog__intro">
          {{ 'restaurantSplitBill.onePaymentReview' | translate }}
        </p>
        <div class="bill-summary">
          <div><span>{{ 'restaurantSplitBill.netAmount' | translate }}</span><span><span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(data.totals.netCents) }}</span></div>
          <div><span>{{ 'restaurantSplitBill.taxAmount' | translate }}</span><span><span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(data.totals.taxCents) }}</span></div>
          <div><span>{{ 'restaurantSplitBill.tip' | translate }}</span><span><span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(data.totals.tipCents) }}</span></div>
          <div class="bill-summary__total"><strong>{{ 'restaurantSplitBill.totalDue' | translate }}</strong><strong><span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(data.totals.totalCents) }}</strong></div>
        </div>
      </section>

      <section *ngIf="step === 'payment'" aria-labelledby="restaurant-settle-title">
        <div class="payment-progress">
          <span>{{ 'restaurantSplitBill.paymentProgress' | translate: {
            paid: split?.paymentSummary?.paidInvoiceCount,
            count: split?.paymentSummary?.invoiceCount
          } }}</span>
          <strong>
            <span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(split?.paymentSummary?.remainingCents) }}
            {{ 'restaurantSplitBill.remaining' | translate }}
          </strong>
        </div>

        <div class="invoice-list">
          <div class="invoice-card invoice-card--payment" *ngFor="let invoice of split?.invoices">
            <div>
              <strong>{{ guestLabel(invoice.position) }}</strong>
              <span class="invoice-card__amount"><span class="currency-prefix" [innerHTML]="data.currencyLabel"></span>{{ money(invoice.totalCents) }}</span>
            </div>
            <button
              *ngIf="invoice.PaymentStatus !== 1; else paidInvoice"
              type="button"
              class="btn-primary"
              [disabled]="saving"
              (click)="setInvoicePaid(invoice, true)"
            >
              {{ (updatingInvoiceId === invoice.invoiceId
                ? 'restaurantSplitBill.updating'
                : 'restaurantSplitBill.recordPayment') | translate }}
            </button>
            <ng-template #paidInvoice>
              <div class="paid-state">
                <span><span aria-hidden="true">&#10003;</span> {{ 'restaurantSplitBill.paymentReceived' | translate }}</span>
                <button
                  type="button"
                  class="btn-link"
                  [appAccessCheck]="'Manage-Restaurant-Orders'"
                  [givenButton]="'delete'"
                  [disabled]="saving"
                  (click)="setInvoicePaid(invoice, false)"
                >
                  {{ (updatingInvoiceId === invoice.invoiceId
                    ? 'restaurantSplitBill.updating'
                    : 'restaurantSplitBill.undoPayment') | translate }}
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </section>
    </ng-container>
  </div>

  <div
    class="modal-footer style-2 restaurant-settle-dialog__footer"
    [class.restaurant-settle-dialog__footer--payment]="step === 'payment'"
    *ngIf="!loading && (step !== 'payment' || split?.canAbandon || isSettled)"
  >
    <button
      type="button"
      class="btn-link"
      *ngIf="step === 'review' || step === 'setup'"
      [disabled]="saving"
      (click)="back()"
    >
      {{ 'restaurantSplitBill.back' | translate }}
    </button>
    <button
      type="button"
      class="btn-link"
      *ngIf="step === 'payment' && split?.canAbandon"
      [disabled]="saving"
      (click)="startOver()"
    >
      {{ 'restaurantSplitBill.voidSplit' | translate }}
    </button>
    <span class="restaurant-settle-dialog__footer-spacer"></span>
    <button
      type="button"
      class="btn-primary"
      *ngIf="step === 'choose'"
      [disabled]="saving"
      (click)="continueFromChoice()"
    >
      {{ 'restaurantSplitBill.continue' | translate }}
    </button>
    <button
      type="button"
      class="btn-primary"
      *ngIf="step === 'setup'"
      [disabled]="saving || !guestCountValid"
      (click)="confirmSplit()"
    >
      {{ (saving ? 'restaurantSplitBill.confirming' : 'restaurantSplitBill.confirmSplit') | translate }}
    </button>
    <button
      type="button"
      class="btn-primary"
      *ngIf="step === 'review'"
      [disabled]="saving"
      (click)="markWholeBillPaid()"
    >
      {{ (saving ? 'restaurantSplitBill.settling' : 'restaurantSplitBill.recordPayment') | translate }}
    </button>
    <button
      type="button"
      class="btn-primary"
      *ngIf="step === 'payment' && isSettled"
      (click)="close()"
    >
      {{ 'Done' | translate }}
    </button>
  </div>
</div>
